import axios from "axios";
import { baseUrl } from "../../common/config";
import { type ParticipantLogin } from "../../models/api/auth";
import { type ApiResponse } from "../../models/api/request";

export const getQuizTypes = () =>
  axios({
    url: `${baseUrl}/api/quiz/quiz-types`,
    method: "GET",
  });

export const getQuizAnswers = (quizType) =>
  axios({
    url: `${baseUrl}/api/quiz/question-answers?quizTypeId=${quizType}`,
    method: "GET",
  });

export const registerUser = (data) =>
  axios.post(`${baseUrl}/api/participant/register`, { ...data });

export const registerFocusUser = (data) =>
  axios.post(`${baseUrl}/api/participant/register-focus`, { ...data });

export const registerExistingParticipant = (data) =>
  axios.post(`${baseUrl}/api/participant/savequiz-oldparticipants`, {
    ...data,
  });

export const login = ({ userName, password }) =>
  axios<ApiResponse<ParticipantLogin>>(
    `${baseUrl}/api/auth/participant/login`,
    {
      method: "POST",
      data: { userName, password },
    }
  );

export const getParticipantProfile = (participantProfileId) =>
  axios.get(
    `${baseUrl}/api/participant?participantProfileId=${participantProfileId}`
  );
